










import {Component,Vue} from "vue-property-decorator";

@Component
export default class Counter extends Vue{
	currentCount=0;

	IncrementCount():void{
		this.currentCount++;
	}
}
